<template>
  <footer class="footer">
    <div class="container">
      <div class="d-sm-block d-md-none">
        <div class="row">
          <div class="col-12 pb-4">
            <p>&#169; <a href="mailto:stephanie.taniguchi@gmail.com?Subject=Hey,%20Stephanie" target="_top"><strong>Stephanie Taniguchi</strong></a></p>
            <p>Visual + Motion Designer</p>
            <p>Bachelor of Arts: Digital Media + Design</p>
            <p>Interactive Arts + Technology</p>
            <p>Simon Fraser University</p>
            <a href="https://www.linkedin.com/in/stephanietaniguchi/" target="_blank">
              <i class="fa fa-linkedin pr-3" style="font-size:1rem;"></i>
            </a>
            <a href="mailto:stephanie.taniguchi@gmail.com?Subject=Hey,%20Stephanie" target="_top">
              <i class="fa fa-envelope pr-3" style="font-size:1rem;"></i>
            </a>
          </div>
        </div>
      </div>
      <div class="d-none d-md-block">
        <div class="row">
          <div class="col-12 col-sm-6 col-md-4 pb-4">
            <p>&#169; <a href="mailto:stephanie.taniguchi@gmail.com?Subject=Hey,%20Stephanie" target="_top"><strong>Stephanie Taniguchi</strong></a></p>
            <p>Visual + Motion Designer</p>
            <p>Bachelor of Arts: Digital Media + Design</p>
            <p>Interactive Arts + Technology</p>
            <p>Simon Fraser University</p>
          </div>
          <div class="col-12 col-sm-6 col-md-4 pb-4">
            <div class="row">
              <div class="col-12">
                <p>Vancouver</p>
                <p>British Columbia</p>
                <p>Canada</p>
              </div>
            </div>
            <div class="row pt-4">
              <div class="col-12">
                <a href="https://www.linkedin.com/in/stephanietaniguchi/" target="_blank">
                  <i class="fa fa-linkedin pr-3" style="font-size:1rem;"></i>
                </a>
                <a href="mailto:stephanie.taniguchi@gmail.com?Subject=Hey,%20Stephanie" target="_top">
                  <i class="fa fa-envelope pr-3" style="font-size:1rem;"></i>
                </a>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-6 col-md-4 pb-4">
            <p class="small text-right">
              Code by <a href="https://github.com/wataruoguchi" target="_blank">Wataru</a>, made with &#60;3
            </p>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'steph-footer'
}
</script>

<style lang="scss" scoped>
footer.footer {
  p {
    font-size: .85rem;
    margin: 0;
  }
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 180px;
  background-color: #f5f5f5;
  .container {
    position: absolute;
    top: 60%;
    left: 0;
    right: 0;
    transform: translateY(-50%);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/StephFooter.vue